import { render, staticRenderFns } from "./StoreDashboard.vue?vue&type=template&id=5071a238&scoped=true"
import script from "./StoreDashboard.vue?vue&type=script&lang=ts"
export * from "./StoreDashboard.vue?vue&type=script&lang=ts"
import style0 from "./StoreDashboard.vue?vue&type=style&index=0&id=5071a238&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5071a238",
  null
  
)

export default component.exports